<template>
    <a class="btn" v-on:click="searchExecute">最安値を検索する</a>
</template>

<script>
    export default ({
        props: {
            // 引数の受け
            condition : {type: Object, require: true},
        },
        methods: {
            searchExecute: function() {
                let paramList = []
                let condition = this.condition

                Object.keys(condition).forEach(function (key) {
                    let searchObject = condition[key]

                    if (searchObject.searchKey) {
                        if (searchObject.value.length) {
                            let value = ""
                            if (Array.isArray(searchObject.value)) {

                                const valueList = []
                                for (let elem of searchObject.value) {
                                    valueList.push(searchObject.master[elem].slug)
                                }
                                value = valueList.join("-")
                            } else {
                                value = searchObject.master[searchObject.value].slug
                            }
                            paramList.push(searchObject.searchKey + "_" + value)
                        } else if (searchObject.searchKey == "date") {
                            let value = searchObject.value
                            let targetMoment = dayjs(value)

                            if(searchObject.isMonth) {
                                value = targetMoment.format("YYYYMM")
                            } else {
                                value = targetMoment.format("YYYYMMDD")
                            }
                            paramList.push(searchObject.searchKey + "_" + value)
                        }
                    }
                })

                location.href = "/search/" + paramList.join("/")
            },
        }
    })
</script>